/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GlobalSettingsResponse
 */
export interface GlobalSettingsResponse {
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsResponse
     */
    loaderLabelName: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsResponse
     */
    firmwareLabelName: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsResponse
     */
    uiLabelName: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsResponse
     */
    customFirmware1LabelName?: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsResponse
     */
    customFirmware2LabelName?: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsResponse
     */
    customFirmware3LabelName?: string;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsResponse
     */
    incorrectRequestsItemsPerPage: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsResponse
     */
    deviceItemsPerPage: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsResponse
     */
    actionHistoryItemsPerPage: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsResponse
     */
    upgradeRuleItemsPerPage: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsResponse
     */
    jobItemsPerPage: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsResponse
     */
    firmwareItemsPerPage: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsResponse
     */
    historyItemsPerPage: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsResponse
     */
    stbGroupItemsPerPage: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsResponse
     */
    jobParallelThreads: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsResponse
     */
    jobExportBatchSize: number;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsResponse
     */
    jobExportBatchWaitDuration: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsResponse
     */
    jobBatchWaitDuration: string;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsResponse
     */
    jobBatchSize: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsResponse
     */
    jobMaxQueued: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsResponse
     */
    maxDeviceHistory: number;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsResponse
     */
    enableDeviceHistory: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsResponse
     */
    enableTags: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsResponse
     */
    enableIpGroup: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsResponse
     */
    enableProvisioning: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsResponse
     */
    enableAutomationApi: boolean;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsResponse
     */
    appUrl: string;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsResponse
     */
    enableStbCommands: boolean;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsResponse
     */
    authLockMessage: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsResponse
     */
    enableRescue: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsResponse
     */
    enableCompareFwVersions: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsResponse
     */
    enableDisablingExtendedVersioning: boolean;
}

export function GlobalSettingsResponseFromJSON(json: any): GlobalSettingsResponse {
    return GlobalSettingsResponseFromJSONTyped(json, false);
}

export function GlobalSettingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalSettingsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'loaderLabelName': json['loaderLabelName'],
        'firmwareLabelName': json['firmwareLabelName'],
        'uiLabelName': json['uiLabelName'],
        'customFirmware1LabelName': !exists(json, 'customFirmware1LabelName') ? undefined : json['customFirmware1LabelName'],
        'customFirmware2LabelName': !exists(json, 'customFirmware2LabelName') ? undefined : json['customFirmware2LabelName'],
        'customFirmware3LabelName': !exists(json, 'customFirmware3LabelName') ? undefined : json['customFirmware3LabelName'],
        'incorrectRequestsItemsPerPage': json['incorrectRequestsItemsPerPage'],
        'deviceItemsPerPage': json['deviceItemsPerPage'],
        'actionHistoryItemsPerPage': json['actionHistoryItemsPerPage'],
        'upgradeRuleItemsPerPage': json['upgradeRuleItemsPerPage'],
        'jobItemsPerPage': json['jobItemsPerPage'],
        'firmwareItemsPerPage': json['firmwareItemsPerPage'],
        'historyItemsPerPage': json['historyItemsPerPage'],
        'stbGroupItemsPerPage': json['stbGroupItemsPerPage'],
        'jobParallelThreads': json['jobParallelThreads'],
        'jobExportBatchSize': json['jobExportBatchSize'],
        'jobExportBatchWaitDuration': json['jobExportBatchWaitDuration'],
        'jobBatchWaitDuration': json['jobBatchWaitDuration'],
        'jobBatchSize': json['jobBatchSize'],
        'jobMaxQueued': json['jobMaxQueued'],
        'maxDeviceHistory': json['maxDeviceHistory'],
        'enableDeviceHistory': json['enableDeviceHistory'],
        'enableTags': json['enableTags'],
        'enableIpGroup': json['enableIpGroup'],
        'enableProvisioning': json['enableProvisioning'],
        'enableAutomationApi': json['enableAutomationApi'],
        'appUrl': json['appUrl'],
        'enableStbCommands': json['enableStbCommands'],
        'authLockMessage': json['authLockMessage'],
        'enableRescue': json['enableRescue'],
        'enableCompareFwVersions': json['enableCompareFwVersions'],
        'enableDisablingExtendedVersioning': json['enableDisablingExtendedVersioning'],
    };
}

export function GlobalSettingsResponseToJSON(value?: GlobalSettingsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'loaderLabelName': value.loaderLabelName,
        'firmwareLabelName': value.firmwareLabelName,
        'uiLabelName': value.uiLabelName,
        'customFirmware1LabelName': value.customFirmware1LabelName,
        'customFirmware2LabelName': value.customFirmware2LabelName,
        'customFirmware3LabelName': value.customFirmware3LabelName,
        'incorrectRequestsItemsPerPage': value.incorrectRequestsItemsPerPage,
        'deviceItemsPerPage': value.deviceItemsPerPage,
        'actionHistoryItemsPerPage': value.actionHistoryItemsPerPage,
        'upgradeRuleItemsPerPage': value.upgradeRuleItemsPerPage,
        'jobItemsPerPage': value.jobItemsPerPage,
        'firmwareItemsPerPage': value.firmwareItemsPerPage,
        'historyItemsPerPage': value.historyItemsPerPage,
        'stbGroupItemsPerPage': value.stbGroupItemsPerPage,
        'jobParallelThreads': value.jobParallelThreads,
        'jobExportBatchSize': value.jobExportBatchSize,
        'jobExportBatchWaitDuration': value.jobExportBatchWaitDuration,
        'jobBatchWaitDuration': value.jobBatchWaitDuration,
        'jobBatchSize': value.jobBatchSize,
        'jobMaxQueued': value.jobMaxQueued,
        'maxDeviceHistory': value.maxDeviceHistory,
        'enableDeviceHistory': value.enableDeviceHistory,
        'enableTags': value.enableTags,
        'enableIpGroup': value.enableIpGroup,
        'enableProvisioning': value.enableProvisioning,
        'enableAutomationApi': value.enableAutomationApi,
        'appUrl': value.appUrl,
        'enableStbCommands': value.enableStbCommands,
        'authLockMessage': value.authLockMessage,
        'enableRescue': value.enableRescue,
        'enableCompareFwVersions': value.enableCompareFwVersions,
        'enableDisablingExtendedVersioning': value.enableDisablingExtendedVersioning,
    };
}

